module.exports = __webpack_public_path__ + "static/img/banner-subscription-expired.d2ee705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-subscription-expired.png
// module id = 8Uf9
// module chunks = 134